export default __webpack_public_path__ + "static/media/about.e12c16e4.png";